"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDifferenceByUnit = void 0;
const getDifferenceInDays_js_1 = require("./getDifferenceInDays.js");
const getDifferenceInHours_js_1 = require("./getDifferenceInHours.js");
const getDifferenceInMinutes_js_1 = require("./getDifferenceInMinutes.js");
const getDifferenceInSeconds_js_1 = require("./getDifferenceInSeconds.js");
const getDifferenceByUnit = (date, unit) => {
    const now = new Date();
    const timeSegments = [
        { units: ['second', 'seconds'], diffFn: getDifferenceInSeconds_js_1.getDifferenceInSeconds },
        { units: ['minute', 'minutes'], diffFn: getDifferenceInMinutes_js_1.getDifferenceInMinutes },
        { units: ['hour', 'hours'], diffFn: getDifferenceInHours_js_1.getDifferenceInHours },
        { units: ['day', 'days'], diffFn: getDifferenceInDays_js_1.getDifferenceInDays },
        {
            units: ['week', 'weeks'],
            diffFn: (dateLeft, dateRight) => (0, getDifferenceInDays_js_1.getDifferenceInDays)(dateLeft, dateRight) / 7,
        },
        // what about months have 31 days, or Feb in leap years
        {
            units: ['month', 'months'],
            diffFn: (dateLeft, dateRight) => (0, getDifferenceInDays_js_1.getDifferenceInDays)(dateLeft, dateRight) / 30,
        },
        // what about months have 31 days, or Feb in leap years
        {
            units: ['quarter', 'quarters'],
            diffFn: (dateLeft, dateRight) => (0, getDifferenceInDays_js_1.getDifferenceInDays)(dateLeft, dateRight) / 90,
        },
        // leap year
        {
            units: ['year', 'years'],
            diffFn: (dateLeft, dateRight) => (0, getDifferenceInDays_js_1.getDifferenceInDays)(dateLeft, dateRight) / 365,
        },
    ];
    return Math.round(timeSegments
        .find((option) => option.units.includes(unit))
        ?.diffFn(now, date) ?? 0);
};
exports.getDifferenceByUnit = getDifferenceByUnit;
//# sourceMappingURL=getDifferenceByUnit.js.map